/* Shopify's current option_selection.js is strict-mode code but writes to an
 * undeclared `property` binding. Minimal's variant picker still depends on it.
 * Declare that legacy binding before option_selection.js loads. */
var property;
